import React, { Component } from "react"
import { Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import UberLogo from "../../../images/dashboard/uber-logo.svg"
import InstaCartLogo from "../../../images/dashboard/instacart-logo.svg"
import USAALogo from "../../../images/dashboard/usaa-logo.svg"
import ShiptLogo from "../../../images/dashboard/shipt-logo.svg"
import UberVehicle from "../../../images/dashboard/uber-vehicle.svg"
import InstaCartVehicle from "../../../images/dashboard/instacart-vehicle.svg"
import USAAVehicle from "../../../images/dashboard/usaa-vehicle.svg"
import ShiptVehicle from "../../../images/dashboard/shipt-vehicle.svg"
import GrubhubLogo from "../../../images/dashboard/grubhub-logo-orange.svg"
import GrubhubVehicle from "../../../images/dashboard/grubhub-vehicle.svg"
import {
  GRUBHUB,
  INSTACART,
  INSTACART_CA,
  SHIPT,
  UBER,
  UBER_CANADA,
  USAA
} from "../../../v1/constants/affiliations"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import AffiliationSiblingModal from "../../../v1/components/Affiliation/AffiliationSiblingModal"

const subDomain = getSubdomain()
class AffilationCards extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { t } = this.props
    const affilationInfo = [
      {
        name: UBER,
        logo: UberLogo,
        image: UberVehicle
      },
      {
        name: UBER_CANADA,
        logo: UberLogo,
        image: UberVehicle
      },
      {
        name: INSTACART,
        logo: InstaCartLogo,
        image: InstaCartVehicle
      },
      {
        name: INSTACART_CA,
        logo: InstaCartLogo,
        image: InstaCartVehicle
      },
      {
        name: USAA,
        logo: USAALogo,
        image: USAAVehicle
      },
      {
        name: SHIPT,
        logo: ShiptLogo,
        image: ShiptVehicle
      },
      {
        name: GRUBHUB,
        logo: GrubhubLogo,
        image: GrubhubVehicle
      }
    ]
    const affilationData = affilationInfo.filter((item) => item.name === subDomain)
    return (
      <React.Fragment>
        {affilationData &&
          affilationData.map((affilation, index) => {
            return (
              <div key={index} className="dashboard-affilation-card">
                <p className="affilation-card-text">{t("discoverYourCarAdviseBenefits")}</p>
                <div style={{ zIndex: "1" }}>
                  <AffiliationSiblingModal
                    affilationName={affilation.name.toLowerCase()}
                    isNewbanner={true}
                  />
                </div>
                <Image
                  className={`affilation-card-logo ${affilation.name.toLowerCase()}-card-logo`}
                  src={affilation.logo}
                />
                <Image
                  className={`${affilation.name.toLowerCase()}-card-vehicle-image`}
                  src={affilation.image}
                />
              </div>
            )
          })}
      </React.Fragment>
    )
  }
}

export default withTranslation("justForYouCards")(AffilationCards)
